export default [
    
    
  //  purchases  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "purchases",
      layout: "dashboard",
    },
    path: "/purchases",
    name: "purchases",
    component: () => import("@/layouts/index/PurchaseIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Les achats",
          layout: "dashboard",
        },
        path: "index",
        name: "purchases-index",
        component: () => import("@/views/purchases/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails sur l'achat",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "purchases-details",
        component: () => import("@/views/purchases/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre l'achat",
          layout: "dashboard",
        },
        path: "create",
        name: "purchases-create",
        component: () => import("@/views/purchases/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier l'achat",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "purchases-edit",
        component: () => import("@/views/purchases/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles à un achat",
          layout: "dashboard",
        },
        path: "items/create",
        name: "purchases-items-create",
        component: () => import("@/views/purchases/items/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'un achat",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "purchases-items-edit",
        component: () => import("@/views/purchases/items/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Rechercher des articles à un achat",
          layout: "dashboard",
        },
        path: "items/search",
        name: "purchases-items-search",
        component: () => import("@/views/purchases/items/Search.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Achats remarquées",
          layout: "dashboard",
        },
        path: "noticed/index",
        name: "purchases-noticed-index",
        component: () => import("@/views/purchases/Noticed.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Achats à valider",
          layout: "dashboard",
        },
        path: "tovalidate/index",
        name: "purchases-tovalidate-index",
        component: () => import("@/views/purchases/ToValidate.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Rapport fournisseur",
          layout: "dashboard",
        },
        path: "supplier/report",
        name: "purchases-supplier-report",
        component: () => import("@/views/purchases/SupplierReport.vue"),
      },
    ],
  },
]